import React, { useState, useEffect, Suspense, lazy } from 'react';
import Tour, { Navigation, Dot, Controls, Arrow } from 'reactour';
import 'focus-outline-manager';
import { GlobalStyle } from './style';
import Text from './Text';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { tourConfig1, tourConfig2 } from './tour.config';

import './styles.css'

// const LazyTour = React.lazy(() =>
//   import(/* webpackChunkName: "reactour" */ '../index')
// )

function TourApp(props) {
  const [isShowingMore, setShowingMore] = useState(false)
  const [customComps, setCustomComps] = useState(false)

  useEffect(() => {
    function keyHandling(e) {
      if (props.isTourOpen && e.keyCode === 13) {
        e.preventDefault()
        setCustomComps(!customComps)
      }
    }
    window.addEventListener('keyup', keyHandling)
    return () => window.removeEventListener('keyup', keyHandling)
  }, [props.isTourOpen, customComps])

  const disableBody = target => disableBodyScroll(target)
  const enableBody = target => enableBodyScroll(target)
  const accentColor = 'linear-gradient(to right, #1c8f9e, #5cb7b7)'
  return (
    <>
      <GlobalStyle />
      <Suspense fallback={<React.Fragment />}>
        <Tour
          onAfterOpen={disableBody}
          onBeforeClose={enableBody}
          onRequestClose={props.onRequestClose}
          steps={(props.level === "1") ? tourConfig1 : tourConfig2}
          isOpen={props.isTourOpen}
          className="helper"
          rounded={5}
          accentColor={accentColor}
          CustomHelper={customComps ? MyCustomHelper : null}
        />
      </Suspense>
    </>
  )
}

function MyCustomHelper({ current, content, totalSteps, gotoStep, close }) {
  const accessories = [
    'Blank',
    'Kurt',
    'Prescription01',
    'Prescription02',
    'Round',
    'Sunglasses',
    'Wayfarers',
  ]
  return (
    <main className="CustomHelper__wrapper">
      <aside className="CustomHelper__sidebar">
        <span className="CustomHelper__sidebar_step">Step {current + 1}</span>
        <img
          className="CustomHelper__sidebar_img"
          src={`https://avataaars.io/?avatarStyle=Circle&topType=LongHairNotTooLong&accessoriesType=${accessories[current]}&hairColor=Brown&facialHairType=BeardLight&facialHairColor=Black&clotheType=BlazerSweater&eyeType=WinkWacky&eyebrowType=UpDownNatural&mouthType=Smile&skinColor=Pale`}
        />
        <span className="CustomHelper__sidebar_step">Lorem Ipsum</span>
      </aside>
      <div className="CustomHelper__content">
        {content}
        <Controls
          data-tour-elem="controls"
          className="CustomHelper__controls"
          style={{ position: 'absolute' }}
        >
          <Arrow
            onClick={() => gotoStep(current - 1)}
            disabled={current === 0}
            className="CustomHelper__navArrow"
          />
          <Navigation data-tour-elem="navigation">
            {Array.from(Array(totalSteps).keys()).map((li, i) => (
              <Dot
                key={li}
                onClick={() => current !== i && gotoStep(i)}
                current={current}
                index={i}
                disabled={current === i}
                showNumber={true}
                data-tour-elem="dot"
              />
            ))}
          </Navigation>
          <Arrow
            onClick={() => gotoStep(current + 1)}
            disabled={current === totalSteps - 1}
            className="CustomHelper__navArrow"
            inverted
          />
        </Controls>
      </div>
    </main>
  )
}

export default TourApp;
